import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "/styles/colors";
import ReadMoreComponent from "./read-more/read-more-component";
import { StyledBackgroundColorThumbnailItemComponent } from "./background-color-thumbnail-item-component.scss";
class BackgroundColorThumbnailItemComponent extends PureComponent {
    render() {
        const { title, link, color } = this.props;
        return /*#__PURE__*/ _jsxs(StyledBackgroundColorThumbnailItemComponent, {
            href: link,
            className: "background-color-thumbnail-item-component",
            style: {
                backgroundColor: colors[color]
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "thumbnail-title",
                    children: title
                }),
                /*#__PURE__*/ _jsx(ReadMoreComponent, {})
            ]
        });
    }
}
export { BackgroundColorThumbnailItemComponent as default };
